<template>
  <modal
    id="modalSuprimentoDeposito"
    titulo="SUPRIMENTOS.DEPOSITO"
    :exibir="exibir"
    :campos="$refs"
    tamanho="xl"
    @fechar="fecharModal"
  >
    <div class="row">
      <div class="col-12">
        <input-text
          ref="descricao"
          v-model="dados.descricao"
          :label="$t('SUPRIMENTOS.NOME')"
          :placeholder="$t('SUPRIMENTOS.NOME')"
          type="text"
          :maxLength="150"
          required
        />
      </div>
      <div class="col-12">
        <input-select-search
          ref="historicoLancamento"
          :label="$t(`FINANCEIRO.INCLUIR_HISTORICO_ESTOQUE`)"
          :options="opcoesHistoricoLancamento"
          v-model="dados.historicoLancamentoId"
          required
        />
      </div>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Services:
import DepositosService from '@/common/services/depositos/depositos.service.js';
import HistoricoLancamentoService from '@/common/services/historico-lancamento/historico-lancamento.service.js';

// Utils & Aux:
import helpers from '@/common/utils/helpers';

// Components:
import Modal from '@/components/modal/Modal';
import { InputText, InputSelectSearch } from '@/components/inputs';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    dados: { type: Object, default: Object },
  },
  components: {
    Modal,
    InputText,
    InputSelectSearch
  },
  mounted() {
    // this.buscarInformacoesEstoque();
  },
  data() {
    return {
      form: {},
      opcoesHistoricoLancamento: []
    };
  },
  watch: {
    dados() {
      this.form = this.dados;
      this.buscarInformacoesEstoque()
    },
  },
  methods: {
    buscarInformacoesEstoque() {
      HistoricoLancamentoService.obterEstoque()
        .then(({ data }) => {
          this.opcoesHistoricoLancamento = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    // FUNÇÕES CRUD:
    salvar() {
      if (!this.validarFormulario()) return;
      !this.form.id ? this.cadastrar() : this.editar();
    },
    cadastrar() {
      this.$store.dispatch(START_LOADING);
      DepositosService.criar(this.form)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'));
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.fecharModal();
        });
    },
    editar() {
      this.$store.dispatch(START_LOADING);
      DepositosService.editar(this.form)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'));
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.fecharModal();
        });
    },
    // FUNÇÕES MODAL:
    fecharModal() {
      this.$emit('fechar', 'deposito');
    },
  },
};
</script>
